import { NgModule } from '@angular/core'
import { PreloadAllModules, RouterModule, Routes } from '@angular/router'
import { HomeGuard } from './guards/home.guard'
import { AuthenticatedGuard } from './guards/authenticated.guard'
import { UnauthenticatedGuard } from './guards/unauthenticated.guard'
import { DashboardPageGuard } from './guards/dashboard-page.guard'
import { PermissionGuard } from './guards/permission.guard'
import { PermissionType } from './constants/global.const'
// import { KomitmenFormLeaveGuard } from './modules/komitmen/komitmen-form/komitmen-form.page'

const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./modules/landing/landing.module').then(
        (m) => m.LandingPageModule,
      ),
  },
  {
    path: 'daftar-agen',
    loadChildren: () =>
      import('./modules/agen-list/agen-list.module').then(
        (m) => m.AgenListModule,
      ),
  },
  {
    path: 'privacy-policy',
    loadChildren: () =>
      import('./modules/privacy-policy/privacy-policy.module').then(
        (m) => m.PrivacyPolicyModule,
      ),
  },
  {
    path: 'home',
    loadChildren: () =>
      import('./modules/home/home.module').then((m) => m.HomePageModule),
    canActivate: [AuthenticatedGuard, HomeGuard],
  },
  {
    path: 'login',
    loadChildren: () =>
      import('./modules/login/login.module').then((m) => m.LoginPageModule),
    canActivate: [UnauthenticatedGuard],
  },
  {
    path: 'register',
    loadChildren: () =>
      import('./modules/register/register.module').then(
        (m) => m.RegisterPageModule,
      ),
    canActivate: [UnauthenticatedGuard],
  },
  {
    path: 'new-password',
    loadChildren: () =>
      import('./modules/first-password/first-password.module').then(
        (m) => m.FirstPasswordPageModule,
      ),
    canActivate: [UnauthenticatedGuard],
  },
  {
    path: 'forgot-password-otp',
    loadChildren: () =>
      import('./modules/forgot-password-otp/forgot-password-otp.module').then(
        (m) => m.ForgotPasswordOtpPageModule,
      ),
    canActivate: [UnauthenticatedGuard],
  },
  {
    path: 'forgot-password-update',
    loadChildren: () =>
      import(
        './modules/forgot-password-update/forgot-password-update.module'
      ).then((m) => m.ForgotPasswordUpdatePageModule),
    canActivate: [UnauthenticatedGuard],
  },
  {
    path: 'boarding',
    loadChildren: () =>
      import('./modules/boarding/boarding.module').then(
        (m) => m.BoardingPageModule,
      ),
  },
  {
    path: 'dashboard',
    loadChildren: () =>
      import('./modules/dashboard/dashboard.module').then(
        (m) => m.DashboardPageModule,
      ),
    canActivate: [AuthenticatedGuard, DashboardPageGuard],
  },
  {
    path: 'create-order',
    loadChildren: () =>
      import('./modules/create-order/create-order.module').then(
        (m) => m.CreateOrderPageModule,
      ),
    canActivate: [AuthenticatedGuard, PermissionGuard],
    data: {
      access: PermissionType.BOOKING_ORDER_CREATE,
    },
  },
  {
    path: 'cart',
    loadChildren: () =>
      import('./modules/cart/cart.module').then((m) => m.CartPageModule),
    canActivate: [AuthenticatedGuard, PermissionGuard],
    data: {
      access: PermissionType.CART_VIEW,
    },
  },
  {
    path: 'checkout',
    loadChildren: () =>
      import('./modules/checkout/checkout.module').then(
        (m) => m.CheckoutPageModule,
      ),
    canActivate: [AuthenticatedGuard, PermissionGuard],
    data: {
      access: PermissionType.CHECKOUT_VIEW,
    },
  },
  {
    path: 'check-rate',
    loadChildren: () =>
      import('./modules/check-rate/check-rate.module').then(
        (m) => m.CheckRatePageModule,
      ),
    canActivate: [AuthenticatedGuard, PermissionGuard],
    data: {
      access: PermissionType.CHECK_RATE_VIEW,
    },
  },
  {
    path: 'payments',
    loadChildren: () =>
      import('./modules/payment/payment-list/payment-list.module').then(
        (m) => m.PaymentListPageModule,
      ),
    canActivate: [AuthenticatedGuard, PermissionGuard],
    data: {
      access: PermissionType.NON_CASH_INVOICING_VIEW,
    },
  },
  {
    path: 'payments/change',
    loadChildren: () =>
      import(
        './modules/payment/payment-change-method/payment-change-method.module'
      ).then((m) => m.PaymentChangeMethodPageModule),
    canActivate: [AuthenticatedGuard, PermissionGuard],
    data: {
      access: PermissionType.NON_CASH_INVOICING_CREATE,
    },
  },
  {
    path: 'payments/:uuid',
    pathMatch: 'full',
    redirectTo: 'payments/:uuid/countdown',
  },
  {
    path: 'payments/:uuid/countdown',
    loadChildren: () =>
      import(
        './modules/payment/payment-countdown/payment-countdown.module'
      ).then((m) => m.PaymentCountdownPageModule),
    canActivate: [AuthenticatedGuard, PermissionGuard],
    data: {
      access: PermissionType.NON_CASH_INVOICING_VIEW,
    },
  },
  {
    path: 'payment-cash',
    loadChildren: () =>
      import(
        './modules/payment-cash/payment-cash-list/payment-cash-list.module'
      ).then((m) => m.PaymentCashListPageModule),
    canActivate: [AuthenticatedGuard, PermissionGuard],
    data: {
      access: PermissionType.CASH_INVOICING_VIEW,
    },
  },
  {
    path: 'payment-cash/:uuid',
    loadChildren: () =>
      import(
        './modules/payment-cash/payment-cash-detail/payment-cash-detail.module'
      ).then((m) => m.PaymentCashDetailPageModule),
    canActivate: [AuthenticatedGuard, PermissionGuard],
    data: {
      access: PermissionType.CASH_INVOICING_VIEW,
    },
  },
  {
    path: 'payment-cash/:uuid/create',
    loadChildren: () =>
      import(
        './modules/payment-cash/payment-cash-checkout/payment-cash-checkout.module'
      ).then((m) => m.PaymentCashCheckoutPageModule),
    canActivate: [AuthenticatedGuard, PermissionGuard],
    data: {
      access: PermissionType.CASH_INVOICING_CREATE,
    },
  },
  {
    path: 'orders',
    loadChildren: () =>
      import('./modules/pesanan/pesanan-list/pesanan-list.module').then(
        (m) => m.PesananListPageModule,
      ),
    canActivate: [AuthenticatedGuard, PermissionGuard],
    data: {
      access: PermissionType.BOOKING_ORDER_VIEW,
    },
  },
  {
    path: 'orders/:uuid',
    loadChildren: () =>
      import('./modules/pesanan/pesanan-detail/pesanan-detail.module').then(
        (m) => m.PesananDetailPageModule,
      ),
    canActivate: [AuthenticatedGuard, PermissionGuard],
    data: {
      access: PermissionType.BOOKING_ORDER_VIEW,
    },
  },
  {
    path: 'inbounds',
    loadChildren: () =>
      import('./modules/inbound/inbound-list/inbound-list.module').then(
        (m) => m.InboundListPageModule,
      ),
    canActivate: [AuthenticatedGuard, PermissionGuard],
    data: {
      access: PermissionType.INBOUND_VIEW,
    },
  },
  {
    path: 'inbounds/:awb/validate',
    loadChildren: () =>
      import('./modules/inbound/inbound-validate/inbound-validate.module').then(
        (m) => m.InboundValidatePageModule,
      ),
    canActivate: [AuthenticatedGuard, PermissionGuard],
    data: {
      access: PermissionType.INBOUND_CREATE,
    },
  },
  {
    path: 'inbounds/cart',
    loadChildren: () =>
      import('./modules/inbound/inbound-cart/inbound-cart.module').then(
        (m) => m.InboundCartPageModule,
      ),
    canActivate: [AuthenticatedGuard, PermissionGuard],
    data: {
      access: PermissionType.INBOUND_VIEW,
    },
  },
  {
    path: 'inbounds/checkout',
    loadChildren: () =>
      import(
        './modules/inbound/inbound-trouble-checkout/inbound-trouble-checkout.module'
      ).then((m) => m.InboundTroubleCheckoutPageModule),
    canActivate: [AuthenticatedGuard, PermissionGuard],
    data: {
      access: PermissionType.INBOUND_CREATE,
    },
  },
  {
    path: 'manifests',
    loadChildren: () =>
      import(
        './modules/outbound/outbound-listing/outbound-listing.module'
      ).then((m) => m.OutboundListingPageModule),
    canActivate: [AuthenticatedGuard, PermissionGuard],
    data: {
      access: PermissionType.HANDOVER_VIEW,
    },
  },
  {
    path: 'manifests/:uuid',
    loadChildren: () =>
      import('./modules/manifest/manifest-detail/manifest-detail.module').then(
        (m) => m.ManifestDetailPageModule,
      ),
    canActivate: [AuthenticatedGuard, PermissionGuard],
    data: {
      access: PermissionType.HANDOVER_VIEW,
    },
  },
  {
    path: 'bags/:uuid',
    pathMatch: 'full',
    redirectTo: 'bags/:uuid/edit',
  },
  {
    path: 'bags/:uuid/edit',
    loadChildren: () =>
      import('./modules/bag/bag-edit/bag-edit.module').then(
        (m) => m.BagEditPageModule,
      ),
    canActivate: [AuthenticatedGuard, PermissionGuard],
    data: {
      access: PermissionType.HANDOVER_VIEW,
    },
  },
  {
    path: 'handovers',
    loadChildren: () =>
      import(
        './modules/handover/handover-listing/handover-listing.module'
      ).then((m) => m.HandoverListingPageModule),
    canActivate: [AuthenticatedGuard, PermissionGuard],
    data: {
      access: PermissionType.HANDOVER_VIEW,
    },
  },
  {
    path: 'handovers/:manifestUuid',
    loadChildren: () =>
      import(
        './modules/handover/handover-courier/handover-courier.module'
      ).then((m) => m.HandoverCourierPageModule),
    canActivate: [AuthenticatedGuard, PermissionGuard],
    data: {
      access: PermissionType.HANDOVER_VIEW,
    },
  },
  {
    path: 'handovers/progress/:manifestUuid',
    loadChildren: () =>
      import('./modules/handover/handover-proses/handover-proses.module').then(
        (m) => m.HandoverProsesPageModule,
      ),
    canActivate: [AuthenticatedGuard, PermissionGuard],
    data: {
      access: PermissionType.HANDOVER_VIEW,
    },
  },
  {
    path: 'contents',
    loadChildren: () =>
      import('./modules/content/content-list/content-list.module').then(
        (m) => m.ContentListPageModule,
      ),
    canActivate: [AuthenticatedGuard],
  },
  {
    path: 'tracking',
    loadChildren: () =>
      import('./modules/tracking/tracking.module').then(
        (m) => m.TrackingPageModule,
      ),
    canActivate: [AuthenticatedGuard, PermissionGuard],
    data: {
      access: PermissionType.TRACKING_VIEW,
    },
  },
  {
    path: 'balances',
    loadChildren: () =>
      import('./modules/balance/balance-listing/balance-listing.module').then(
        (m) => m.BalanceListingPageModule,
      ),
    canActivate: [AuthenticatedGuard, PermissionGuard],
    data: {
      access: PermissionType.SALDO_MUTATION_VIEW,
    },
  },
  {
    path: 'pendapatan-agen',
    loadChildren: () =>
      import('./modules/pendapatan-agen/pendapatan-agen-listing/pendapatan-agen-listing.module').then(
        (m) => m.PendapatanAgenListingPageModule,
      ),
    canActivate: [AuthenticatedGuard, PermissionGuard],
    data: {
      access: PermissionType.BUPOT_AGEN_VIEW,
    },
  },
  {
    path: 'pendapatan-agen/detail/:uuid',
    loadChildren: () =>
      import('./modules/pendapatan-agen/pendapatan-agen-detail/pendapatan-agen-detail.module').then(
        (m) => m.PendapatanAgenDetailPageModule,
      ),
    canActivate: [AuthenticatedGuard, PermissionGuard],
    data: {
      access: PermissionType.BUPOT_AGEN_VIEW,
    },
  },
  {
    path: 'balances/courier/:uuid',
    loadChildren: () =>
      import(
        './modules/balance/balance-detail/balance-detail-courier/balance-detail-courier.module'
      ).then((m) => m.BalanceDetailCourierPageModule),
    canActivate: [AuthenticatedGuard, PermissionGuard],
    data: {
      access: PermissionType.SALDO_MUTATION_VIEW,
    },
  },
  {
    path: 'balances/pickup/:uuid',
    loadChildren: () =>
      import(
        './modules/balance/balance-detail/balance-detail-pickup/balance-detail-pickup.module'
      ).then((m) => m.BalanceDetailPickupPageModule),
    canActivate: [AuthenticatedGuard, PermissionGuard],
    data: {
      access: PermissionType.SALDO_MUTATION_VIEW,
    },
  },
  {
    path: 'balances/invoice/:uuid',
    loadChildren: () =>
      import(
        './modules/balance/balance-detail/balance-detail-invoice/balance-detail-invoice.module'
      ).then((m) => m.BalanceDetailInvoicePageModule),
    canActivate: [AuthenticatedGuard, PermissionGuard],
    data: {
      access: PermissionType.SALDO_MUTATION_VIEW,
    },
  },
  {
    path: 'balances/claim',
    loadChildren: () =>
      import('./modules/balance/balance-claim/balance-claim.module').then(
        (m) => m.BalanceClaimPageModule,
      ),
    canActivate: [AuthenticatedGuard, PermissionGuard],
    data: {
      access: PermissionType.SALDO_MUTATION_CREATE,
    },
  },
  {
    path: 'balances/claim/:uuid',
    loadChildren: () =>
      import(
        './modules/balance/balance-claim-detail/balance-claim-detail.module'
      ).then((m) => m.BalanceClaimDetailPageModule),
    canActivate: [AuthenticatedGuard, PermissionGuard],
    data: {
      access: PermissionType.SALDO_MUTATION_VIEW,
    },
  },
  {
    path: 'pending-balance',
    loadChildren: () =>
      import(
        './modules/balance/balance-pending-listing/balance-pending-listing.module'
      ).then((m) => m.BalancePendingListingPageModule),
    canActivate: [AuthenticatedGuard, PermissionGuard],
    data: {
      access: PermissionType.SALDO_PENDING_UPDATE,
    },
  },
  {
    path: 'settings',
    pathMatch: 'full',
    redirectTo: 'settings/profile',
  },
  {
    path: 'settings/menu',
    loadChildren: () =>
      import('./modules/setting/setting-menu/setting-menu.module').then(
        (m) => m.SettingMenuPageModule,
      ),
    canActivate: [AuthenticatedGuard],
  },
  {
    path: 'settings/profile',
    loadChildren: () =>
      import('./modules/setting/setting-profile/setting-profile.module').then(
        (m) => m.SettingProfilePageModule,
      ),
    canActivate: [AuthenticatedGuard],
  },
  {
    path: 'settings/agent',
    loadChildren: () =>
      import('./modules/setting/setting-agen/setting-agen.module').then(
        (m) => m.SettingAgenPageModule,
      ),
    canActivate: [AuthenticatedGuard],
  },
  {
    path: 'settings/employee',
    loadChildren: () =>
      import('./modules/setting/setting-employee/setting-employee.module').then(
        (m) => m.SettingEmployeePageModule,
      ),
    canActivate: [AuthenticatedGuard],
  },
  {
    path: 'settings/employee/add',
    loadChildren: () =>
      import(
        './modules/setting/setting-employee/setting-employee-add/setting-employee-add.module'
      ).then((m) => m.SettingEmployeeAddPageModule),
    canActivate: [AuthenticatedGuard, PermissionGuard],
    data: {
      access: PermissionType.EMPLOYEE_CREATE,
    },
  },
  {
    path: 'settings/employee/:uuid',
    loadChildren: () =>
      import(
        './modules/setting/setting-employee/setting-employee-detail/setting-employee-detail.module'
      ).then((m) => m.SettingEmployeeDetailPageModule),
    canActivate: [AuthenticatedGuard, PermissionGuard],
    data: {
      access: PermissionType.EMPLOYEE_VIEW,
    },
  },
  {
    path: 'quota-payment/:uuid',
    loadChildren: () =>
      import(
        './modules/quota/quota-payment-detail/quota-payment-detail.module'
      ).then((m) => m.QuotaPaymentDetailModule),
    canActivate: [AuthenticatedGuard, PermissionGuard],
    data: {
      access: PermissionType.NON_CASH_INVOICING_VIEW,
    },
  },
  {
    path: 'quota-payment/:uuid/change',
    loadChildren: () =>
      import(
        './modules/quota/quota-payment-change/quota-payment-change.module'
      ).then((m) => m.QuotaPaymentChangePageModule),
    canActivate: [AuthenticatedGuard, PermissionGuard],
    data: {
      access: PermissionType.NON_CASH_INVOICING_VIEW,
    },
  },
  // {
  //   path: 'komitmen/form',
  //   loadChildren: () =>
  //     import('./modules/komitmen/komitmen-form/komitmen-form.module').then(
  //       (m) => m.KomitmenFormPageModule,
  //     ),
  //   canActivate: [AuthenticatedGuard],
  // },
  // {
  //   path: 'komitmen',
  //   loadChildren: () =>
  //     import('./modules/komitmen/komitmen-detail/komitmen-detail.module').then(
  //       (m) => m.KomitmenDetailPageModule,
  //     ),
  //   canActivate: [AuthenticatedGuard],
  // },
  // {
  //   path: 'komitmen/form',
  //   loadChildren: () =>
  //     import('./modules/komitmen/komitmen-form/komitmen-form.module').then(
  //       (m) => m.KomitmenFormPageModule,
  //     ),
  //   canActivate: [AuthenticatedGuard],
  //   canDeactivate: [KomitmenFormLeaveGuard],
  // },
  // {
  //   path: 'komitmen',
  //   loadChildren: () =>
  //     import('./modules/komitmen/komitmen-detail/komitmen-detail.module').then(
  //       (m) => m.KomitmenDetailPageModule,
  //     ),
  //   canActivate: [AuthenticatedGuard],
  // },
  {
    path: 'remote-area',
    loadChildren: () =>
      import('./modules/remote-area/remote-area.module').then(
        (m) => m.RemoteAreaPageModule,
      ),
    canActivate: [AuthenticatedGuard, PermissionGuard],
    data: {
      access: PermissionType.REMOTE_AREA_VIEW,
    },
  },
  {
    path: 'address',
    loadChildren: () =>
      import('./modules/address/address-list/address-list.module').then(
        (m) => m.AddressListModule,
      ),
    canActivate: [AuthenticatedGuard, PermissionGuard],
    data: {
      access: PermissionType.ADDRESS_VIEW,
    },
  },
  {
    path: 'dokumen-pks',
    loadChildren: () =>
      import('./components/document/document-pks/document-pks.module').then(
        (m) => m.DocumentPKSPageModule,
      ),
    canActivate: [AuthenticatedGuard],
  },
  {
    path: 'dokumen-snk',
    loadChildren: () =>
      import('./components/document/document-snk/document-snk.module').then(
        (m) => m.DocumentSnkPageModule,
      ),
  },
  {
    path: 'edit-order/:uuid',
    loadChildren: () =>
      import('./modules/create-order/create-order.module').then(
        (m) => m.CreateOrderPageModule,
      ),
    canActivate: [AuthenticatedGuard, PermissionGuard],
    data: {
      access: PermissionType.BOOKING_ORDER_CREATE,
    },
  },
  {
    path: 'account-verify',
    loadChildren: () =>
      import('./modules/account-verify/account-verify.module').then(
        (m) => m.AccountVerifyPageModule,
      ),
  },
  {
    path: 'pengajuan',
    loadChildren: () =>
      import('./modules/pengajuan/pengajuan.module').then(
        (m) => m.PengajuanPageModule,
      ),
    canActivate: [AuthenticatedGuard],
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: 'login',
  },
]

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      canceledNavigationResolution: 'computed',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
